import { T } from '../model';


/**
 * Check Value is boolean or not
 * @param val
 * @returns boolean value
 */
export const isBool = (val: T) => 'boolean' === typeof val;
